/* eslint-disable no-redeclare */
import { z } from 'zod';

export const LookingForHelpDto = z.enum([
  'compare_plans',
  'lower_costs',
  'doctor_coverage',
  'learn',
  'existing_plan',
  'something_else',
]);

export type LookingForHelpDto = z.infer<typeof LookingForHelpDto>;
